import { PharmacInputError, PharmacLabel } from '@pharmac/ui'
import { PropsWithChildren } from 'react'
import { Controller } from 'react-hook-form'
import { PharmacMultiSelect } from '.'
import { ControlledInputProps } from './dto'

export const ControlledMultiSelect = (props: ControlledInputProps & PropsWithChildren) => {
  if (
    props.rules &&
    Object.keys(props.rules).length > 0 &&
    !Object.keys(props.rules).includes('validate')
  ) {
    console.warn(
      `ControlledMultiSelect (${props.name}) should be validated with 'validate' -rule. (see:https://react-hook-form.com/docs/useform/register#options) `
    )
  }

  return (
    <>
      {!!props.label && <PharmacLabel marginSmallBottom>{props.label}</PharmacLabel>}
      <Controller
        control={props.control}
        rules={props.rules}
        name={props.name}
        render={({ field, formState }) => {
          const error = formState.errors[props.name] ?? false

          return (
            <>
              <PharmacMultiSelect
                value={field.value || []}
                onChange={field.onChange}
                error={!!formState.errors[props.name]}
              >
                {props.children}
              </PharmacMultiSelect>
              {error && typeof error.message === 'string' && (
                <PharmacInputError>{error.message}</PharmacInputError>
              )}
            </>
          )
        }}
      />
    </>
  )
}
